import React from "react";

import mixpanel from "../../../lib/mixPanel";

const getPictureUrl = url => {
  let replacedWidth = (url && url.replace("[WIDTH]", "280")) || "";
  const newUrl =
    (replacedWidth && replacedWidth.replace("[HEIGHT]", "280")) || "";
  return newUrl;
};

export default class PopularListItem extends React.PureComponent {
  render() {
    const { category, handleSelectCategory } = this.props;
    const url = getPictureUrl(category.picture.url);
    return (
      <li
        className="items"
        onClick={() => {
          mixpanel.track("Click Popular Category", {
            Category: category.name
          });
          handleSelectCategory(category.name);
        }}
      >
        <div>
          <div className="img">
            <img src={url} />
          </div>
          <div className="name">
            <label>{category.name}</label>
          </div>
        </div>
      </li>
    );
  }
}
